module.exports = __webpack_public_path__ + "img/yuerjia.56eeab83.png";